import { render } from "./UserPerformance.vue?vue&type=template&id=3f56b6a0&scoped=true"
import script from "./UserPerformance.vue?vue&type=script&lang=js"
export * from "./UserPerformance.vue?vue&type=script&lang=js"

import "./UserPerformance.vue?vue&type=style&index=0&id=3f56b6a0&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f56b6a0"]])

export default __exports__